import React from 'react';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';

// Create routes using createBrowserRouter
const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />
  }
]);

/**
 * Performance optimization: Only render in requestAnimationFrame 
 * to ensure smoother page loads by not competing with browser's
 * critical rendering tasks.
 */
const render = () => {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }
  
  createRoot(rootElement).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
};

// Use requestIdleCallback if available for even better performance
if (typeof window.requestIdleCallback !== 'undefined') {
  window.requestIdleCallback(render);
} else {
  // Fallback to requestAnimationFrame
  window.requestAnimationFrame(render);
}